import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { client, urlFor } from "../sanityClient";
import BlockContent from "@sanity/block-content-to-react";
import BlogPhoto from "../assets/blog-photo.jpg";

function Blog() {
  const [posts, setPosts] = useState([]);
  const [hover, setHover] = useState(null);

  useEffect(() => {
    const query = `*[_type == "post"]{
      _id,
      title,
      slug,
      mainImage,
      publishedAt,
      body
    } | order(publishedAt desc)`;

    client
      .fetch(query)
      .then((data) => setPosts(data))
      .catch((error) => {
        console.error("Error fetching posts:", error);
      });
  }, []);

  return (
    <div style={styles.container}>
      {/* Hero Section */}
      <div style={styles.heroSection}>
        <img
          src={BlogPhoto}
          alt="Blog Hero"
          style={styles.heroImage}
        />
        <div style={styles.heroOverlay}>
          <h1 style={styles.heroTitle}>POVESTI SI ISTORIOARE</h1>
        </div>
      </div>

      {/* Blog Section */}
      <div style={styles.blogSection}>
        {posts.length > 0 ? (
          <div style={styles.grid}>
            {posts.map((post, index) => (
              <div
                key={post._id}
                style={styles.card}
                onMouseEnter={() => setHover(index)}
                onMouseLeave={() => setHover(null)}
              >
                <img
                  src={urlFor(post.mainImage).width(600).url()}
                  alt={post.title}
                  style={styles.cardImage}
                />
                <div style={styles.cardContent}>
                  <h2 style={styles.cardTitle}>{post.title}</h2>
                  <p style={styles.cardMeta}>
                    Published on <strong>{new Date(post.publishedAt).toDateString()}</strong>
                  </p>
                  <p style={styles.cardSnippet}>
                    <BlockContent blocks={post.body} />
                  </p>
                  <Link
                    to={`/blog/${post.slug.current}`}
                    style={{
                      ...styles.readMore,
                      color: hover === index ? "#001F54" : "#4A4A4A",
                    }}
                  >
                    Read More »
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p style={styles.noPosts}>No blog posts found.</p>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    fontFamily: "'Georgia', serif",
    backgroundColor: "#FFFFFF",
    margin: 0,
    padding: 0,
  },
  heroSection: {
    position: "relative",
    left: "50%",
    right: "50%",
    marginLeft: "-50vw",
    marginRight: "-50vw",
    width: "100vw",
    height: "40vh",
    overflow: "hidden",
    backgroundColor: "#000", // fallback
  },
  heroImage: {
    position: "absolute",
    top: "0",
    left: "50%",
    width: "100%",
    height: "100%",
    transform: "translateX(-50%)",
    objectFit: "cover",
    objectPosition: "center down",
  },
  heroOverlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    color: "#FFFFFF",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    padding: "1rem",
    borderRadius: "8px",
  },
  heroTitle: {
    fontSize: "3rem",
    fontWeight: "bold",
    margin: 0,
    color: "#FFFFFF",
  },
  blogSection: {
    padding: "2rem",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "2rem",
  },
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    transition: "transform 0.3s ease",
  },
  cardImage: {
    width: "100%",
    height: "200px",
    objectFit: "cover",
  },
  cardContent: {
    padding: "1.5rem",
  },
  cardTitle: {
    fontSize: "1.5rem",
    color: "#4A4A4A",
    marginBottom: "0.5rem",
  },
  cardMeta: {
    fontSize: "0.9rem",
    color: "#888888",
    marginBottom: "1rem",
  },
  cardSnippet: {
    fontSize: "1rem",
    lineHeight: "1.6",
    color: "#4A4A4A",
    marginBottom: "1rem",
  },
  readMore: {
    textDecoration: "underline",
    fontWeight: "bold",
    fontSize: "1rem",
    cursor: "pointer",
  },
  noPosts: {
    textAlign: "center",
    fontSize: "1.2rem",
    color: "#4A4A4A",
  },
};

export default Blog;
